/**
 * Get country code by a language code using the map defined in 'COUNTRY_CODE_BY_LANGUAGE_CODE'.
 *
 * @param {string} languageCode
 * @param {string} [defaultResult='xx']
 * @return {string}
 */
export const getCountryCodeByLanguageCode = (languageCode, defaultResult = 'xx') => {
	let COUNTRY_CODE_BY_LANGUAGE_CODE = new Map();
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['nl-NL', 'nl', 'nl-BE'], 'nl');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['en-US', 'en'], 'us');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['fr-FR', 'fr'], 'fr');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['de-DE', 'de'], 'de');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['it-IT', 'it'], 'it');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['ja-JP', 'ja'], 'jp');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['pt-PT', 'pt'], 'pt');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['sr-RS', 'sr'], 'rs');
	COUNTRY_CODE_BY_LANGUAGE_CODE.set(['es-ES', 'es'], 'es');
	
	let result = defaultResult;
	
	if (!!languageCode) {
		const entities = COUNTRY_CODE_BY_LANGUAGE_CODE.entries();
		
		for (const [key, value] of entities) {
			if (key.map(i => i.toLowerCase()).includes(languageCode.toLowerCase())) {
				result = value;
				break;
			}
		}
	}
	
	return result;
};